import axios from "axios";

export const getInvoices = (userId, { isPayed = null, isReversed = null }) => {
  let query = "";

  if (isPayed !== null) {
    query = `?isPayed=${isPayed}`;
  }

  if (isReversed !== null) {
    query += `${query !== "" ? "&" : "?"}isReversed=${isReversed}`;
  }

  return axios.get(`/user/${userId}/invoice${query}`);
};

export const getInvoiceTypes = () => {
  return axios.get(`/invoice/types`);
};

export const getInvoicePdf = (userId, invoiceId) => {
  return axios.get(`/invoice/${invoiceId}/pdf`, {
    responseType: "blob",
  });
};

export const markInvoiceAsPayed = (userId, ShoppingCartId, WsPayOrderId) => {
  return axios.post(`/user/${userId}/invoice/pay-online`, {
    ShoppingCartId,
    WsPayOrderId,
  });
};

export const payAllSignature = ({ userId, invoiceIds }) => {
  return axios.post(`user/${userId}/invoice/pay-all-reference`, {
    InvoiceIds: invoiceIds,
  });
};
